import AI from "./AI";

export default AI;
